import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=3f5f79b1&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=3f5f79b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f79b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5f79b1')) {
      api.createRecord('3f5f79b1', component.options)
    } else {
      api.reload('3f5f79b1', component.options)
    }
    module.hot.accept("./AuthForm.vue?vue&type=template&id=3f5f79b1&scoped=true", function () {
      api.rerender('3f5f79b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/role/AuthForm.vue"
export default component.exports